import { AutoComplete } from "antd";
import { useIntl } from "react-intl";

import { useVenueSelect } from "./hooks";
import { VenueSelectProps } from "./types";

const VenueSelect: React.FC<VenueSelectProps> = ({
  value,
  onChange,
  ...props
}) => {
  const intl = useIntl();
  const venueSelect = useVenueSelect({ value, onChange });

  return (
    <AutoComplete
      {...venueSelect}
      placeholder={intl.formatMessage({ defaultMessage: "Choose venue" })}
      {...props}
    />
  );
};

export default VenueSelect;
